import { FC, memo } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Flex,
  Form,
  Row,
  Select,
  TimeRangePickerProps
} from 'antd';
import { DatePickerProps } from 'antd/lib';
import dayjs from 'dayjs';
import { useAppSelector } from 'store/hooks';
import {
  selectAnalyticsUtmValuesData,
  selectAnalyticsUtmValuesLoading
} from 'store/analytics/selectors';

const rangePresets: TimeRangePickerProps['presets'] = [
  {
    label: 'Yesterday',
    value: [
      dayjs().add(-1, 'd').startOf('day'),
      dayjs().add(-1, 'd').endOf('day')
    ]
  },
  {
    label: 'Last 7 Days',
    value: [dayjs().add(-7, 'd').startOf('day'), dayjs()]
  },
  {
    label: 'Last 14 Days',
    value: [dayjs().add(-14, 'd').startOf('day'), dayjs()]
  },
  {
    label: 'Last 30 Days',
    value: [dayjs().add(-30, 'd').startOf('day'), dayjs()]
  },
  {
    label: 'Last 90 Days',
    value: [dayjs().add(-90, 'd').startOf('day'), dayjs()]
  }
];

interface IProps {
  dateMode?: DatePickerProps['picker'];
  onReset(): void;
}

const Filters: FC<IProps> = ({ dateMode, onReset }) => {
  const loading = useAppSelector(selectAnalyticsUtmValuesLoading);
  const utmValues = useAppSelector(selectAnalyticsUtmValuesData);

  const form = Form.useFormInstance();

  const onClickReset = () => {
    form.resetFields();
    onReset();
  };

  return (
    <Flex justify="space-between" gap={24} wrap="wrap">
      <Row style={{ flex: 1 }} gutter={8}>
        <Col span={6}>
          <Form.Item name="dates">
            <DatePicker.RangePicker
              presets={dateMode === 'date' ? rangePresets : undefined}
              picker={dateMode}
              allowClear={false}
              disabledDate={current =>
                current && current > dayjs().endOf('day')
              }
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="utm_medium">
            <Select
              allowClear
              showSearch
              placeholder="Medium"
              options={utmValues?.utm_mediums.map(item => ({
                label: item,
                value: item
              }))}
              loading={loading}
              disabled={loading}
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="utm_campaign">
            <Select
              allowClear
              showSearch
              placeholder="Campaign"
              options={utmValues?.utm_campaigns.map(item => ({
                label: item,
                value: item
              }))}
              loading={loading}
              disabled={loading}
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="utm_term">
            <Select
              allowClear
              showSearch
              placeholder="Term"
              options={utmValues?.utm_terms.map(item => ({
                label: item,
                value: item
              }))}
              loading={loading}
              disabled={loading}
            />
          </Form.Item>
        </Col>
      </Row>
      <Flex gap={8}>
        <Button onClick={onClickReset}>Reset</Button>
        <Button type="primary" htmlType="submit">
          Apply
        </Button>
      </Flex>
    </Flex>
  );
};

export default memo(Filters);
